<div data-at-active-error class="error-container flex flex-col gap-[16px]">
  <div class="flex flex-row justify-between items-start">
    <div class="error-description break-word">
      {{ activeError?.errorDescription | translate }}
    </div>
    <app-pill [type]="pillType.error">
      {{ activeError?.errorCode }}
    </app-pill>
  </div>

  <div class="flex flex-col gap-[8px]">
    <div class="flex flex-row gap-[8px] justify-start items-center">
      <ng-container *ngIf="devicesStore.isV2Cascade$ | async">
        <ng-container *ngrxLet="devicesStore.getCascadeMemberId(activeError.deviceId) as memberId">
          <ng-container
            *ngIf="
              (devicesStore.getCascadeDeviceById(activeError.deviceId) | async)
                ?.shortDeviceName as shortDeviceName;
              else noShortDeviceName
            "
          >
            <ng-container *ngIf="shortDeviceName; else noShortDeviceName">
              <div class="device-type" matTooltip="{{ shortDeviceName | translate }}">
                {{ shortDeviceName }}
              </div>
            </ng-container>
          </ng-container>
          <ng-template #noShortDeviceName>
            <div
              class="device-type"
              matTooltip="{{
                '+INSTALLATIONS.INSTALLATION.CASCADES.MULTIVALENT.DEVICE.' +
                  activeError?.deviceType?.toUpperCase() | translate
              }} {{ memberId }}"
            >
              {{
                '+INSTALLATIONS.INSTALLATION.CASCADES.MULTIVALENT.DEVICE.' +
                  activeError?.deviceType?.toUpperCase() | translate
              }}
              {{ memberId }}
            </div>
          </ng-template>
        </ng-container>
      </ng-container>
      <div class="date">{{ installationLocalTimeOfErrorAppearedAt | date: 'short' }}</div>
    </div>

    <div *ngIf="activeError?.deviceType === deviceTypes.Zigbee" class="flex flex-col gap-[4px]">
      <div class="flex flex-col">
        <span class="device-name">
          {{ gatewayStore.getDeviceRoles(activeError?.deviceId) | async | translateDeviceByRoles }}
        </span>
        <ng-container
          *ngIf="getDeviceNameFeature(activeError?.deviceId) | async | ready as deviceName"
        >
          <span class="device-name" *ngIf="deviceName.properties.name.value">
            {{ '+INSTALLATIONS.INSTALLATION.ERROR_LIST.DEVICE_DESC' | translate }}:
            {{ deviceName | value2: featurePropertyKey.name }}
          </span>
        </ng-container>
        <span class="device-id">
          {{ '+INSTALLATIONS.INSTALLATION.ERROR_LIST.DEVICE_ID' | translate }}
          {{ activeError?.deviceId | idPrefixRemover | serialSpacing }}
        </span>
      </div>
      <div
        class="flex flex-row flex-wrap"
        *ngIf="
          installationFeaturesStore.getDeviceRoom(activeError?.deviceId) | async | ready as room
        "
      >
        <span class="room-name">
          {{
            '+INSTALLATIONS.INSTALLATION.ERROR_LIST.ACTIVE_ERROR_INFORMATION.ROOM_NAME' | translate
          }}
          {{ room?.properties?.name?.value }}
        </span>
      </div>
      <div class="border-bottom"></div>
    </div>

    <vi-loader
      *ngIf="activeError?.loading; else showData"
      data-at-loader
      [isLoading]="true"
      message="{{
        '+INSTALLATIONS.INSTALLATION.ERROR_LIST.ACTIVE_ERROR_INFORMATION.LOADING_MESSAGE'
          | translate
      }}"
    ></vi-loader>

    <ng-template #showData>
      <ng-container *ngIf="activeError?.details; else noData">
        <div *ngIf="activeError?.details?.causes[0] as causes" class="cause">
          {{
            '+INSTALLATIONS.INSTALLATION.ERROR_LIST.ACTIVE_ERROR_INFORMATION.POSSIBLE_CAUSE'
              | translate
          }}
          <div class="break-word" *ngIf="causes.cause">
            <ng-container
              *ngFor="let item of causes.cause | htmlExtractor: 'p':HTMLExtractionPrefix.DASH"
            >
              <div>{{ item }}</div>
            </ng-container>
          </div>
        </div>
      </ng-container>

      <ng-template #noData>
        <div class="no-data">
          {{
            '+INSTALLATIONS.INSTALLATION.ERROR_LIST.ACTIVE_ERROR_INFORMATION.HMI_VIEW' | translate
          }}:
        </div>
        <div class="no-data__description">
          {{ getErrorCodeTranslation(activeError.errorCode, !!activeError.errorDescription) }}
        </div>
      </ng-template>
    </ng-template>

    <div
      *ngIf="activeError?.details"
      class="repair-now flex flex-row justify-start items-center w-full min-w-full h-full min-h-full"
    >
      <button
        data-at-gts-more-details
        mat-stroked-button
        appSmallButton
        class="repair-now__btn"
        color="secondary"
        gtm="onSelect"
        gtmAction="Error details navigate"
        gtmCategory="active error"
        [disabled]="moreInfoDisabled"
        (click)="navigateToErrorDetails()"
      >
        {{
          '+INSTALLATIONS.INSTALLATION.ERROR_LIST.ACTIVE_ERROR_INFORMATION.BUTTON_REDIRECT_TITLE'
            | translate
        }}
      </button>
    </div>

    <a
      class="go-to-viassist"
      gtm="onSelect"
      gtmAction="Go to ViAssist page"
      gtmCategory="active error"
      data-at-go-to-vi-assist-page
      [routerLink]="['/assistant']"
      [queryParams]="{
        viassist_search: activeError?.errorCode,
        isSetDefaultLanguageFilter: 'true'
      }"
    >
      {{
        '+INSTALLATIONS.INSTALLATION.ERROR_LIST.ACTIVE_ERROR_INFORMATION.GO_TO_VIASSIST' | translate
      }}
    </a>
  </div>
</div>
